import React from 'react';
import { Link } from 'react-router-dom';
import { useComparisonGrid } from '../providers/comparison_grid';
import AnchorColumnHeader from './anchor_column_header';
import ClauseTitleColumn from './clause_title_column';
import Column from './column';
const ComparisonGridTable = () => {
    const { anchorDoc, comparatorDocs } = useComparisonGrid();
    return React.createElement("div", { className: 'comparison-grid', "data-testid": 'comparison-grid' },
        React.createElement("div", { className: 'left-anchor' },
            React.createElement(ClauseTitleColumn, { "data-testid": 'anchor-titles-column' }),
            React.createElement("div", { className: 'anchor-document', "data-testid": 'anchor-document-column' },
                React.createElement(AnchorColumnHeader, null),
                React.createElement("div", { className: 'scroll-space column' }),
                React.createElement(Column, { doc: anchorDoc, columnId: 1 })),
            React.createElement("div", { className: 'right-container', "data-testid": 'documents-container' },
                React.createElement("div", { className: 'headers' },
                    React.createElement("div", { name: 'scrollHeader', className: 'scroller syncscroll', "data-testid": 'document-headers' }, comparatorDocs.map((doc, index) => (React.createElement("div", { key: `${doc.documentComparisonFileId}-header-cell`, className: 'column' },
                        React.createElement("div", { className: 'header cell', "data-testid": `cell-0-${index + 2}` },
                            React.createElement(Link, { target: '_blank', to: {
                                    pathname: `/document/${doc.fileId}`,
                                    search: '',
                                }, className: 'title-text overflow-ellipsis', title: doc.fileName }, doc.fileName))))))),
                React.createElement("div", { className: 'scroll-space syncscroll', name: 'scrollHeader' }, comparatorDocs.map(doc => (React.createElement("div", { key: `${doc.documentComparisonFileId}-phant`, className: 'phantom-column' })))),
                React.createElement("div", { className: 'documents syncscroll', name: 'scrollHeader' }, comparatorDocs.map((doc, index) => {
                    const columnId = index + 2;
                    return (React.createElement(Column, { key: `${doc.documentComparisonFileId}-column-cells`, doc: doc, columnId: columnId }));
                })))));
};
export default ComparisonGridTable;
